// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";

export const fallbackFont = "Arial, Helvetica, sans-serif";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    product: {
        image: {
            // Store Custom Code
            small: getImageSize(210), // auto complete, checkout
            medium: getImageSize(640), // PLP
            large: getImageSize(1200), // Zoom in
        },
    },
    category: {
        image: {
            // Store Custom Code
            small: getImageSize(500), // CDP
        },
    },
    // Store Custom Code
    typography: {
        fontFamily: {
            base: `'urw-din', ${fallbackFont}`,
            title: `'urw-din', ${fallbackFont}`,
            secondary: `'urw-din-condensed', ${fallbackFont}`,
        },
    },
    header: {
        height: pxToRemArray([65, null, 90, null, 100]),
        padding: pxToRemArray([11, null, 22]),
        itemSpacing: pxToRemArray([2, null, 20, 25, 30]),
        subItemSpacing: pxToRemArray([2, null, 20, 25, 30]),
    },
};

export default design;
